import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { TakeoffData, TakeoffListItemAttached } from "@ServerTypes/takeoffs/takeoffs.schema";
import type { MeasurementItem } from "@ServerTypes/measurements/measurements.schema";

export interface MeasurementModalStatus {
  status: boolean;
}

const measurementsListSlice = createSlice({
  name: "measurementsList",
  initialState: [] as MeasurementItem[],
  reducers: {
    setMeasurementsData: (_state: MeasurementItem[], action: PayloadAction<MeasurementItem[] | undefined>) =>
      action.payload ?? [],
  },
});

const takeoffsListSlice = createSlice({
  name: "takeoffsList",
  initialState: [] as TakeoffListItemAttached[],
  reducers: {
    setTakeoffsList: (
      _state: TakeoffListItemAttached[],
      action: PayloadAction<TakeoffListItemAttached[] | undefined>,
    ) => (action.payload as TakeoffListItemAttached[]) ?? [],
  },
});

const takeoffDataSlice = createSlice({
  name: "takeoffData",
  initialState: {} as Partial<TakeoffData>,
  reducers: {
    setTakeoff: (_state: Partial<TakeoffData>, action: PayloadAction<Partial<TakeoffData>>) => action.payload,
  },
});

const measurementsModalStatusSlice = createSlice({
  name: "measurementsModalStatus",
  initialState: { status: false } as MeasurementModalStatus,
  reducers: {
    setMeasurementsModalStatus: (_state: MeasurementModalStatus, action: PayloadAction<MeasurementModalStatus>) =>
      action.payload,
  },
});

const isMeasurementStartedSlice = createSlice({
  name: "isMeasurementStarted",
  initialState: { status: false } as MeasurementModalStatus,
  reducers: {
    setIsMeasurementStarted: (_state: MeasurementModalStatus, action: PayloadAction<MeasurementModalStatus>) =>
      action.payload,
  },
});

export const { setMeasurementsData } = measurementsListSlice.actions;

export const { setTakeoffsList } = takeoffsListSlice.actions;
export const { setTakeoff } = takeoffDataSlice.actions;
export const { setMeasurementsModalStatus } = measurementsModalStatusSlice.actions;
export const { setIsMeasurementStarted } = isMeasurementStartedSlice.actions;

export const measurementsList = measurementsListSlice.reducer;
export const takeoffsList = takeoffsListSlice.reducer;
export const takeoffData = takeoffDataSlice.reducer;
export const measurementsModalStatus = measurementsModalStatusSlice.reducer;
export const isMeasurementStarted = isMeasurementStartedSlice.reducer;
